module.exports = __webpack_public_path__ + "static/mujeres002.thumb-aeebe19b94ea321b449f5ba5c5e9afa1.jpg";